import { Navigate, Route, Routes } from "react-router-dom";
import BedView from "../../pages/BedView/BedView";
import DoctorDashboard from "../../pages/Dashboard/DoctorDashboard";
import DischargeSummary from "../../pages/DischargeSummary/DischargeSummary";
import DrRound from "../../pages/DrRound/DrRound";
import IntakeOutputChart from "../../pages/IntakeOutputChart/IntakeOutputChart";
import MedicalRecords from "../../pages/MedicalRecords/MedicalRecords";
import CasePaper from "../../pages/CasePaper/CasePaper";
import NursingNotes from "../../pages/NursingNotes/NursingNotes";
import OTNote from "../../pages/OTNote/OTNote";
import PathologyResultApproval from "../../pages/PathologyResultApproval/PathologyResultApproval";
import PurchaseOrderApproval from "../../pages/PurchaseOrderApproval/PurchaseOrderApproval";
import RmoNotes from "../../pages/RmoNotes/RmoNotes";
import TPR from "../../pages/TPR/TPR";

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Navigate to="/dashboard" replace />} />
    <Route path="/dashboard" element={<DoctorDashboard />} />
    <Route path="/dr-round" element={<DrRound />} />
    <Route path="/ot-note" element={<OTNote />} />
    <Route path="/discharge-summary" element={<DischargeSummary />} />
    <Route path="/medical-records" element={<MedicalRecords />} />
    <Route path="/case-paper" element={<CasePaper />} />
    <Route path="/bed-view" element={<BedView />} />
    <Route path="/pathology-result-approval" element={<PathologyResultApproval />} />
    <Route path="/purchase-order-approval" element={<PurchaseOrderApproval />} />
    <Route path="/intake-output-chart" element={<IntakeOutputChart />} />
    <Route path="/tpr" element={<TPR />} />
    <Route path="/nursing-notes" element={<NursingNotes />} />
    <Route path="/rmo-notes" element={<RmoNotes />} />
    <Route path="*" element={<Navigate to="/dashboard" replace />} />
  </Routes>
);

export default AppRoutes;
